import { defineStore } from 'pinia';
import LocalStorage from 'Core/commons/LocalStorage';
import { OcrLineMode } from 'composables/ocr/types';

export interface Permissions {
    create_pur_invoice: boolean;
    create_pur_credit_note: boolean;
    create_payment: boolean;
}

interface OcrVerificationState {
    permissions: Permissions;
    lineMode: OcrLineMode;
}

const META_URL = 'ocr/pur-invoice/metas';

const lineModeStorage = new LocalStorage('ocr', 'form.lineMode');

const isOcrLineMode = (value: unknown): value is OcrLineMode =>
    value === OcrLineMode.PRODUCT || value === OcrLineMode.TAX;

const readPersistedLineMode = (): OcrLineMode => {
    const stored = lineModeStorage.get();
    return isOcrLineMode(stored) ? stored : OcrLineMode.PRODUCT;
};

export const useOcrVerificationStore = defineStore('ocrVerification', {
    state: (): OcrVerificationState => ({
        permissions: {
            create_pur_invoice: false,
            create_pur_credit_note: false,
            create_payment: false,
        },
        lineMode: readPersistedLineMode(),
    }),
    actions: {
        async loadMeta(): Promise<void> {
            const response = await ApiClient.get(META_URL);
            const data = response?.data;
            if (data && typeof data === 'object') {
                this.permissions = { ...this.permissions, ...(data as Partial<Permissions>) };
            }
        },
        setLineMode(mode: OcrLineMode): void {
            this.lineMode = mode;
            lineModeStorage.set(mode);
        },
    },
});
